import React from 'react';
import PropTypes from 'prop-types';

const Notification = ({ facet, children }) => (
    <div className={`notification notification__${ facet }`}>
        <div className={`notification--body`}>
            {children}
        </div>
    </div>
);

Notification.propTypes = {
    children: PropTypes.any.isRequired,
    facet: PropTypes.string.isRequired,
};

export default Notification;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/notification/index.js